module.exports = __webpack_public_path__ + "media/images/marketing/hero-background-d08ccc6d49f5561272f90ce06b3e57db20d696831cccb855013a31265c997edb.jpg";